<template>
  <div class="content-main">
    <HeaderBar :text="activities.header" :backgroundUrl="activities.headerUrl"></HeaderBar>
    <div class="content">
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-lg-4" v-for="(item, index) in activities.activities" :key="index">
            <div class="item-img">
              <img :src="`/${$staticPath}/${item.src}`">
              <div class="text">
                <div class="head">
                  <h3>{{item.header}}</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBar from '../COMMON/HeaderBar.vue'

export default {
  components: {
    HeaderBar
  },
  props: ['activities']
}
</script>

<style scoped>
  .content-main {
    padding-bottom: 60px 0;
    background-image: linear-gradient(to top, rgba(240, 240, 240, 0.05), #FFA500);
  }

  .content {
    padding: 90px 0;
  }

  .item-img {
    margin-bottom: 30px;
    position: relative;
  }

  .item-img img {
    width: 100%;
    border: 5px solid rgba(0, 0, 0, 0);
  }

  .item-img:hover img {
    border: 5px solid #FFA500;
  }

  .item-img .text {
    position: absolute;
    padding: 10px 15px 10px 15px;
    left: 5px;
    right: 5px;
    bottom: 5px;
    background-color: rgba(25, 25, 25, 0.7);
  }

  .item-img .text h3 {
    margin: 0;
    font-size: 16px;
    color: #FFA500;
  }

</style>



// WEBPACK FOOTER //
// src/components/STUDENTS/Activities.vue